import React, { useEffect, useState } from "react";
import "./NotePreview.css";
import { useLazyQuery } from "@apollo/client";
import { getUserByID } from "../../../graphql/queries";

const NotePreview = ({ note, updatedBy }) => {
  const [userName, setUserName] = useState(null);
  const [fetchUserById, { data }] = useLazyQuery(getUserByID);

  useEffect(() => {
    if (updatedBy) {
      fetchUserById({ variables: { id: updatedBy } });
    }
  }, [updatedBy, fetchUserById]);

  useEffect(() => {
    if (data?.getUser) {
      const user = data.getUser;
      const fullName = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      setUserName(fullName || "Unknown");
    }
  }, [data]);

  if (!note) return null;

  return (
    <div className="note-preview-container">
      <div className="note-preview-content">
        <p className="note-text">{note}</p>
        {userName && <p className="note-updated-by">By: {userName}</p>}
      </div>
    </div>
  );
};

export default NotePreview;
